import { useEffect } from 'react';
import { Object3D, Scene } from 'three';

import { isDefined } from '../../../utils/variables';

export function useObject3d(scene: Scene | undefined, object3d: Object3D | undefined) {
  useEffect(() => {
    if (!isDefined(scene) || !isDefined(object3d)) {
      return;
    }

    // Define as variables so the reference isn't changed between render cycles.
    const _scene = scene;
    const _object3d = object3d;

    _scene.add(_object3d);

    return () => {
      _scene.remove(_object3d);
    };
  }, [scene, object3d]);
}
